// extracted by mini-css-extract-plugin
module.exports = {"root":"AppStarRating_root__7To4h","ratingLabel":"AppStarRating_ratingLabel__Y2Zph"};